var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screening-headline"},[_c('p',{staticClass:"headline"},[_vm._v(" あなたの腫れ・むくみについて、以下の項目をご回答ください。 ")])])}]

export { render, staticRenderFns }